var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.loadingPage)?_c('v-card',{staticClass:"loader",staticStyle:{"top":"0"},attrs:{"loading":true}}):(!_vm.$store.state.loadingPage)?_c('v-card',{staticClass:"loader",staticStyle:{"top":"-5px"},attrs:{"loading":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }